// Centralized theme colors for the Firewatch app

export const theme = {
  // Primary colors
  primary: '#FF7700', // Orange - main brand color
  primaryLight: '#ff8c42', // Soft orange - for OK buttons
  
  // Status colors
  success: '#28a745',
  warning: '#ffc107',
  danger: '#dc3545',
  info: '#17a2b8',
  
  // Map colors
  userLocationMarker: '#FF7700', // Orange for user location
  extinguisherMarker: '#e74c3c', // Red for extinguishers
  
  // UI colors
  background: '#f8f9fa',
  text: '#2c3e50',
  textSecondary: '#6c757d',
  textLight: '#999',
  
  // Button colors
  buttonPrimary: '#ff8c42', // Soft orange
  buttonSecondary: '#6c757d',
  buttonDanger: '#dc3545',
  
  // Alert colors
  alertError: {
    background: '#f8d7da',
    text: '#721c24'
  },
  alertSuccess: {
    background: '#d4edda',
    text: '#155724'
  },
  alertInfo: {
    background: '#e3f2fd',
    text: '#1565c0'
  }
};

export default theme;
